import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

/**
 * Context global de l'application
 * Gère les états partagés entre composants (menu, projets, etc.)
 */

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fermer le menu mobile lors du changement de route
  useEffect(() => {
    const handleRouteChange = () => {
      setIsMobileMenuOpen(false);
    };

    window.addEventListener('popstate', handleRouteChange);
    return () => window.removeEventListener('popstate', handleRouteChange);
  }, []);

  // Lock body scroll quand menu mobile ouvert
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = useCallback(() => {
    setIsMobileMenuOpen(prev => !prev);
  }, []);

  const closeMobileMenu = useCallback(() => {
    setIsMobileMenuOpen(false);
  }, []);

  const openMobileMenu = useCallback(() => {
    setIsMobileMenuOpen(true);
  }, []);

  // Fonction pour charger les projets (si nécessaire)
  const loadProjects = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      // Logic de chargement des projets
      // const data = await apiGet('/projets');
      // setProjects(data);
    } catch (err) {
      setError(err.message);
      console.error('Erreur chargement projets:', err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const value = {
    // Menu mobile
    isMobileMenuOpen,
    toggleMobileMenu,
    closeMobileMenu,
    openMobileMenu,

    // Projets
    projects,
    setProjects,
    loadProjects,

    // États globaux
    isLoading,
    setIsLoading,
    error,
    setError,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

/**
 * Hook pour utiliser le contexte de l'app
 * @returns {Object} Le contexte de l'application
 */
export function useApp() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp doit être utilisé à l\'intérieur d\'un AppProvider');
  }
  return context;
}

export default AppContext;
